import { render, staticRenderFns } from "./VehiclesListView.vue?vue&type=template&id=081184c8&scoped=true&"
import script from "./VehiclesListView.vue?vue&type=script&lang=js&"
export * from "./VehiclesListView.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesListView.vue?vue&type=style&index=0&id=081184c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081184c8",
  null
  
)

export default component.exports